import Axios from 'axios';
import api from './api';
import { ProjetoOrdemInvestimentoPlurianualTotalizador } from './projeto';
import { trackPromise } from 'react-promise-tracker';
import { getJwt } from '@app/helpers';

export interface ProjetoOrdemInvestimentoADistribuirTotalizador extends ProjetoOrdemInvestimentoPlurianualTotalizador {
  anoMes: TotalToAno[];
  anoMesADistribuir: TotalToAno[];
  anoReferencia: string;
  ultimoMesAno: string;
  ano: number;
  mes: number;
}

export interface TotalToAno {
  totalColunaAnoMes: string;
  anoMes: string;
  dataIndex: string;
  totalColuna: string;
}

export interface OrdemInvestimentoFornecedor {
  ordemInvestimentoid: string,
  fornecedorId: string,
  tipoDistribuicaoForcastId: string,
};


export interface OrdemInvestimentoPcm {
  ordemInvestimentoId: string,
  pcmId: string,
  tipoDistribuicaoForcastId: string,
};

export interface OrdemInvestimentoRequisitado {
  ordemInvestimentoId: string,
  tipoDistribuicaoForcastId: string,
};

export interface OrdemInvestimentoContratado {
  ordemInvestimentoId: string,
  tipoDistribuicaoForcastId: string,
};

export const getAllADistribuirByProjetoId = (id: any) => api.get<ProjetoOrdemInvestimentoADistribuirTotalizador>(`projetos/getAllADistribuirByProjetoId/${id}`);

export const postAdcionarMesAno = (

  dataFornecedor: OrdemInvestimentoFornecedor[],
  dataPcm: OrdemInvestimentoPcm[],
  dataRequisitado: OrdemInvestimentoRequisitado[],
  dataContratado: OrdemInvestimentoContratado[],
  projetoId: string,
  ultimoMesAno: string) => {


  const ordemInvestimentoADistribuirForm = {
    ultimoMesAno: ultimoMesAno,
    projetoId: projetoId,
    ordemInvestimentoFornecedor: dataFornecedor,
    ordemInvestimentoPcm: dataPcm,
    ordemInvestimentoRequisitado: dataRequisitado,
    ordemInvestimentoContratado: dataContratado,
  }
  return api.post<ProjetoOrdemInvestimentoADistribuirTotalizador>('projetos/adcionarMesAno', ordemInvestimentoADistribuirForm);
}

export const updateTipoDistribuicaoConsolidadoPlurianual = (consolidadoPlurianualId: string, tipoDistribuicaoForcastId: string, projetoId: string) => {

  const updateTipoDistribuicaoConsolidadoPlurianualCommand = {
    "consolidadoPlurianualId": consolidadoPlurianualId,
    "tipoDistribuicaoForcastId": tipoDistribuicaoForcastId,
    "projetoId": projetoId
  }

  return api.put<ProjetoOrdemInvestimentoADistribuirTotalizador>('consolidadoPlurianual/updateTipoDistribuicaoConsolidadoPlurianual', updateTipoDistribuicaoConsolidadoPlurianualCommand);
}



export const updatePeriodoInicialConsolidadoPluriAnual = (
  consolidadoPlurianualId: string,
  ordemInvestimentoId: string,
  dataInicial: string,
  projetoId: string,
  valorADistribuir: number
) => {

  const UpdatePeriodoInicialConsolidadoPluriAnualCommand = {
    "consolidadoPlurianualId": consolidadoPlurianualId,
    "ordemInvestimentoId": ordemInvestimentoId,
    "dataInicial": dataInicial,
    "projetoId": projetoId,
    "valorADistribuir": valorADistribuir
  }

  return api.put<ProjetoOrdemInvestimentoADistribuirTotalizador>('consolidadoPlurianual/updatePeriodoInicialConsolidadoPluriAnual', UpdatePeriodoInicialConsolidadoPluriAnualCommand);
}

export const updatePeriodoFinalConsolidadoPluriAnual = (
  consolidadoPlurianualId: string,
  ordemInvestimentoId: string,
  dataFinal: string,
  projetoId: string,
  valorADistribuir: number

) => {

  const UpdatePeriodoFinalConsolidadoPluriAnualCommand = {
    "consolidadoPlurianualId": consolidadoPlurianualId,
    "ordemInvestimentoId": ordemInvestimentoId,
    "DataFinal": dataFinal,
    "projetoId": projetoId,
    "valorADistribuir": valorADistribuir
  }
  return api.put<ProjetoOrdemInvestimentoADistribuirTotalizador>('consolidadoPlurianual/updatePeriodoFinalConsolidadoPluriAnual', UpdatePeriodoFinalConsolidadoPluriAnualCommand);
}

export const CreatAdcionarMesAno = (projtoId: string, ano: number, mes: number) => {
  const CreatAdcionarMesAnoCommand = {
    "projetoId": projtoId,
    "ano": ano,
    "mes": mes
  }
  return api.post<ProjetoOrdemInvestimentoADistribuirTotalizador>('consolidadoPlurianual/creatAdcionarMesAno', CreatAdcionarMesAnoCommand);
}

export const updateValorConsolidadoPluriAnualItemDistribuir = (
  id: string,
  projetoId: string,
  valor: number,
  codigo: string
) => {

  const updateValorConsolidadoPluriAnualItemDistribuirCommand = {
    "id": id,
    "projetoId": projetoId,
    "valor": valor,
    "codigo": codigo,
  }
  return api.put<ProjetoOrdemInvestimentoADistribuirTotalizador>('consolidadoPlurianual/updateValorConsolidadoPluriAnualItemDistribuir', updateValorConsolidadoPluriAnualItemDistribuirCommand);
}
export const getConsolidadoPluriAnualItemDistribuir = (id: string) => api.get<ProjetoOrdemInvestimentoADistribuirTotalizador>(`projetos/getConsolidadoPluriAnualItemDistribuir/${id}`);



export const exportarADistribuir = (id: string, nomeProjeto: string) => {
  let urlBase = window.location.origin;

  trackPromise(
    Axios.get(
      urlBase +
      `/api/projetos/exportarADistribuir/${id}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${getJwt()}`,
        },
      },
    ).then(resp => {

      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `aDistribuir${nomeProjeto}.xlsx`);
      link.setAttribute('id', 'downloadElementADistribuir');
      document.body.appendChild(link);
      link.click();
      document.getElementById('downloadElementADistribuir').outerHTML = '';
    }),
  );
}

